import { CommonModule } from '@angular/common';
import { Component, Input, TemplateRef, ViewChild } from '@angular/core';

import { InfoboxComponent } from '@recruitee/components/infobox';
import { TranslatePipe } from '@recruitee/i18n';
import { CompanyVerificationRequestStatus } from '@recruitee/spam-verification-data';

@Component({
  standalone: true,
  selector: 'rt-spam-verification-status-infobox',
  templateUrl: './spam-verification-status-infobox.component.html',
  styleUrls: ['./spam-verification-status-infobox.component.less'],
  imports: [CommonModule, InfoboxComponent, TranslatePipe],
})
export class SpamVerificationStatusInfoboxComponent {
  @Input() public status: CompanyVerificationRequestStatus;

  @ViewChild('companyVerificationRequestStatusRejected', { static: true })
  public companyVerificationRequestStatusRejected: TemplateRef<any>;
  @ViewChild('companyVerificationRequestStatusApproved', { static: true })
  public companyVerificationRequestStatusApproved: TemplateRef<any>;
  @ViewChild('companyVerificationRequestStatusFormSubmitted', { static: true })
  public companyVerificationRequestStatusFormSubmitted: TemplateRef<any>;

  public activeTemplate: TemplateRef<any> | null;

  public ngOnChanges(): void {
    this.activeTemplate = this.resolveInfoboxTemplate();
  }

  private resolveInfoboxTemplate(): TemplateRef<any> | null {
    switch (this.status) {
      case CompanyVerificationRequestStatus.Approved:
        return this.companyVerificationRequestStatusApproved;

      case CompanyVerificationRequestStatus.Rejected:
        return this.companyVerificationRequestStatusRejected;

      case CompanyVerificationRequestStatus.FormSubmitted:
        return this.companyVerificationRequestStatusFormSubmitted;

      default:
        return null;
    }
  }
}
